export default [
  {
    path: '/real-estate-developments-settings/accessories-categorization',
    name: 'AccessoriesCategorizationList',
    component: () => import(
      'pages/real-estate-developments-settings/accessories-categorization/AccessoriesCategorizationList.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/accessories-categorization/new',
    name: 'AccessoriesCategorizationCreate',
    component: () => import(
      'pages/real-estate-developments-settings/accessories-categorization/AccessoriesCategorizationForm.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/accessories-categorization/:id/edit',
    name: 'AccessoriesCategorizationEdit',
    component: () => import(
      'pages/real-estate-developments-settings/accessories-categorization/AccessoriesCategorizationForm.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/accessories-categorization/:id',
    name: 'AccessoriesCategorizationSingle',
    component: () => import(
      'pages/real-estate-developments-settings/accessories-categorization/AccessoriesCategorizationSingle.vue'
    )
  }
]
